module.exports = __webpack_public_path__ + "exo-latin-500.81d3a72e86d04e574f0d.woff";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-500.woff
// module id = ../../../../typeface-exo/files/exo-latin-500.woff
// module chunks = styles